<div class="container margin-top-20">
  <div class="row">
    <div class="col-lg-4 col-md-5 col-sm-12">
      <div class="user-profile-box">
        <div class="header clearfix">
          <h3>{{FullName}}</h3>
          <img [src]="ProfileImageUrl" alt="UserName" class="img-fluid profile-img">
        </div>
        <div class="detail clearfix">
          <ul class="my-account-nav">
            <li class="sub-nav-title">Manage Account</li>
            <li><a [routerLink]="'/account/profile'" class="current"><i class="sl sl-icon-user"></i> My Profile</a></li>
          </ul>
          <ul class="my-account-nav">
            <li class="sub-nav-title">Manage Listings</li>
            <li><a [routerLink]="'/account/properties'"><i class="sl sl-icon-docs"></i> My
                Properties</a></li>
            <li><a [routerLink]="'/property/forms/submit'"><i class="sl sl-icon-action-redo"></i> Submit New Property</a></li>
          </ul>
          <ul class="my-account-nav no-border-bottom">
            <li><a [routerLink]="'/account/change-password'"><i class="sl sl-icon-lock"></i> Change Password</a></li>
            <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-7 col-sm-12">
      <div class="notification notice">
        <div class="form-group pl-10">
          <h3>Account Information
            <a [routerLink]="'/account/profile/edit'" class="pull-right pr-20"><i class="fa fa-edit"></i>
            </a>
          </h3>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>First Name:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <span>{{userProfile?.FirstName}}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>Last Name:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <label>{{userProfile?.LastName}}</label>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>User Name:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <label>{{userProfile?.UserName}}</label>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>Email Address:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <label>{{userProfile?.EmailAddress}}</label>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>Phone:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <label>{{userProfile?.Phone}}</label>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>Address:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <label>{{userProfile?.Address}}</label>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <label>About:</label>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12">
          <label>{{userProfile?.About}}</label>
        </div>
      </div>
    </div>
  </div>
</div>
